module.exports = __webpack_public_path__ + "static/media/AboutYalaMap.19e6edb6.png";